module.exports = __webpack_public_path__ + "img/text.36b015e1.svg";